import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useGetUserQuery } from '../api/user.js';
import Splash from '../components/layout/Splash.jsx';

const CurrentUser = () => {
    const accessToken = localStorage.getItem('accessToken');
    const user = useSelector((state) => state.user);

    useGetUserQuery({}, { skip: !!user.user || (!user.user && accessToken === null) });

    if (user.isLoading && accessToken !== null) {
        return <Splash />;
    }

    return <Outlet />;
};

export default CurrentUser;
